import { uuid } from './regex';

export const ExternalRoutes = {
    path: 'external',
    rental: {
        path: 'rental',
        contract: {
            path: `:resourceId(${uuid})`,
            billing: {
                path: 'billing',
                details: {
                    path: `:billingId(${uuid}|\\d+)`,
                    creditCard: {
                        path: ':hash',
                    },
                    pdf: {
                        path: 'pdf',
                    },
                },
            },
            rentAdvanceRedir: {
                path: 'rentAdvanceRedir',
            },
        },
        newToken: {
            path: 'newToken',
        },
    },
    landlordArea: {
        path: 'landlordArea',
        home: {
            path: `:workspaceId(${uuid})`,
            accessToken: {
                path: 'accessToken',
                new: {
                    path: 'new',
                },
            },
            properties: {
                path: 'properties',
                property: {
                    path: ':propertyId([0-9]+)',
                    splits: {
                        path: 'splits',
                    },
                },
            },
            rentAdvances: {
                path: 'rentAdvances',
                details: {
                    path: ':rentAdvanceId([0-9]+)',
                    purchase: {
                        path: 'purchase',
                        summary: {
                            path: 'summary',
                        },
                        result: {
                            path: 'result',
                        },
                    },
                },
            },
        },
    },
};
